export default {
  toasts: {
    load_error: 'Échec du chargement des taux de frais',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
  rates: {
    title: 'Marge de traitement',
    description:
      "Pourcentage en %, plus un montant fixe et un montant minimum facultatifs par paiement. « Tout mode de paiement » s'applique lorsqu'aucun taux propre au mode de paiement n'existe.",
  },
};
